<template>
  <div class="home rj-content">
    <h1 v-if="info.user_data.names">Hola, {{info.user_data.names}} </h1>
    <h1 v-else>Hola</h1>
    <div class="banner"></div>
    <v-row>
      <v-col sm="12" md="12">
        <v-row>
          <img src="../assets/cover.png" alt="" width="100%">
        </v-row>
      </v-col>
    </v-row>
    <v-row class="ctn-cards">
      <v-col sm="12" md="4" xs="12" col="12" class="ctn-cards-home justify-center">
        <v-card link :to="'/mi-perfil'">
          <div class="ctn-img">
            <img src="../assets/contact-card.png" width="75px"/>
          </div>
          <v-card-title>
            <h3 class="title-card">Mi perfil</h3>
          </v-card-title>
          <v-card-text>
            <p>Aquí podrás ver y actualizar la información personal que compartes con nosotros.</p>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col sm="12" md="4" xs="12" col="12"  class="ctn-cards-home justify-center">
        <v-card link :to="'/consultas'">
          <div class="ctn-img">
            <img src="../assets/query.png" width="60px"/>
          </div>
          <v-card-title>
            <h3 class="title-card">Consulta personal</h3>
          </v-card-title>
          <v-card-text>
            <p>Agenda una consulta personal conmigo y analizaremos tu carta astral durante una sesión presencial o
              virtual.</p>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col sm="12" md="4" xs="12" col="12" class="ctn-cards-home justify-center">
        <v-card link :to="'/carta-astral'">
          <div class="ctn-img">
            <img src="../assets/carta-astral.png"/>
          </div>
          <v-card-title>
            <h3 class="title-card">Carta astral</h3>
          </v-card-title>
          <v-card-text>
            <p>Este mapa te ayudará a entender mejor tu forma de ser y comportamientos, así como el contexto que te
              rodea.</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import {mapActions, mapState} from "vuex";
  export default {
    name: 'Hello',
    computed: {
      ...mapState('user',[
        'info',
      ]),
    },
    methods: {
      ...mapActions(['loaderChange']),
      ...mapActions(
          'user', [
            'fetchInfo',
          ]
      ),
    },
    mounted() {
      this.loaderChange(true)
      this.fetchInfo().finally(() => {
        this.loaderChange(false)
      })
    }
  }
</script>
<style lang="scss" scoped>
	$breakpoints: (
			'tablet': 768px,
	);
	@mixin mobile {
		@media screen and (max-width: map-get($breakpoints, tablet)) {
			@content;
		}
	}
::v-deep .title-card {
  color: #656565;
}
h3 {
  font-size: 16px;
}
.row {
  > div {
    display: flex;
  }
}
::v-deep .v-card {
  min-height: 340px;
	@include mobile {
		min-height: 100px;
	}
  .ctn-img {
    width: 100%;
    height: 120px;
    padding-top: 40px;
    display: flex;
    align-items: center;
  }

  img {
    display: block;
    margin: 20px auto;
    max-width: 150px;
  }

  h3 {
    margin-top: 20px;
  }

  p {
    font-size: 12px;
  }
}
  .ctn-cards {
    ::v-deep .v-card {
      max-width: 400px;
    }
  }
	.ctn-cards-home {
		@include mobile {
			width: 100% !important;
			display: block !important;
			flex-basis: unset;
		}
	}
</style>
